import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  collegeDegreeLength: 0,
  collegeDegree: [],
  specializationError: "",
  formError: "",
}

export default function collegeDegreeReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_COLLEGE_DEGREE:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_COLLEGE_DEGREE:
      return {...state, saveLoader: action.payload}
    case actions.GET_COLLEGE_DEGREE:
      return {...state, collegeDegree: action.payload.collegeDegree, collegeDegreeLength: action.payload.collegeDegreeLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.COLLEGE_DEGREE_FAIL:
      return { ...state, specializationError: action.payload };
    default:
      return {...state};
  }
}